import React from "react";
import {UseCaseItemContainer, UseCaseNumber, UseCaseContent, UseCaseItemTitle, UseCaseDescription} from "./UseCaseItem.css";

export interface UseCaseItemProps {
    number: string;
    title: string;
    description: string;
}

const UseCaseItem = ({number, title, description}: UseCaseItemProps) => {

    return (
        <div className={UseCaseItemContainer}>
            <div className={UseCaseNumber}>{number}.</div>
            <div className={UseCaseContent}>
                <span className={UseCaseItemTitle}>{title}</span>
                <span> </span>
                <span className={UseCaseDescription}>{description}</span>
            </div>
        </div>
    );
};

export default UseCaseItem;